export default __webpack_public_path__ + "static/output-baf429ca84940615488fb9841ec1a07d.jpg";